import {ActionTypes} from '../../actions';
import createReducer from '../../../common/util/createReducer';
import {wtsDefaultArea} from '../../../common/dictionaries/parameters';

const INITIAL_STATE = {
  'areas': [],
  'areaSelected': '',
  'loading': false,
};

export const wtsAreas = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_WTS_AREAS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_WTS_AREAS]: (state, action) => ({
      ...state,
      'loading': false,
      'areas': action.response.data,
      'areaSelected': action.response.data.find((x) => x.description.toUpperCase() === wtsDefaultArea.toUpperCase()),
    }),
    [ActionTypes.FETCHED_WTS_AREAS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'areas': [],
      'areaSelected': '',
    }),
    [ActionTypes.CHANGE_WTS_AREA_SELECTED]: (state, action) => ({
      ...state,
      'loading': false,
      'areaSelected': action.payload,
    }),
    [ActionTypes.CLEAR_WTS_AREAS]: (state, action) => ({
      ...state,
      'areas': [],
    }),
  })(state, action);
};
